// extracted by mini-css-extract-plugin
export default {"SubHeaderWithETAAndGoToItinerary":"cvqw4","ETA":"bUxR2","buttonGoToAddress":"eek3W"};